import { api } from "Requests/Api";
import { Agent } from "frontend-lib/DomainTypes/User";
import React, { useEffect, useState } from "react";


export default function useAllUsers() : [Agent[]]{
    const [users,setUsers] = useState<Agent[]>([])

    const fetchAllUsers = async () => {
        let users: Agent[] = [];
        let page = 0;
        let hasNext = false;
        
        do {
            let res = await api.users().get(null, page);
            users = [...users, ...res.data.users];
            page = page + 1;
            hasNext = res.data.paginator.hasNext;
        } while (hasNext);

        setUsers(users)
    };

    useEffect(() => {
        fetchAllUsers()
    }, [])

    return [users]
}